// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'blocks-solid';

export const Component = () => (
  <path d='M21.073 20.593H9.53c-.335 0-.526.144-.526.479 0 .335.191.526.526.526h11.543c.335 0 .526-.191.526-.526s-.191-.479-.526-.479Zm-14.703 0H3.927v-2.442c0-.335-.143-.48-.479-.48-.335 0-.526.145-.526.48v2.442H.48c-.335 0-.48.144-.48.479 0 .335.145.526.48.526h2.442v2.443c0 .335.191.479.526.479.336 0 .48-.144.48-.48v-2.442H6.37c.335 0 .478-.191.478-.526s-.143-.479-.478-.479ZM0 6.848V0h24.521v6.848H0Zm0 8.86V8.813h24.521v6.897H0Z' />
);

export const viewBox = '0 0 25 25';
